"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vault__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: 'address',
                name: '_gate',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_weth',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'CannotPayOff',
        type: 'error',
    },
    {
        inputs: [],
        name: 'EmptyName',
        type: 'error',
    },
    {
        inputs: [],
        name: 'InsufficientCommission',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'evil',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'requested',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'available',
                type: 'uint256',
            },
        ],
        name: 'InsufficientShare',
        type: 'error',
    },
    {
        inputs: [],
        name: 'InvalidMsgValue',
        type: 'error',
    },
    {
        inputs: [],
        name: 'MaxOrderNums',
        type: 'error',
    },
    {
        inputs: [],
        name: 'MaxPairNums',
        type: 'error',
    },
    {
        inputs: [],
        name: 'MaxRangeNums',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'evil',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'NoDirectTransfer',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'evil',
                type: 'address',
            },
        ],
        name: 'NotFactory',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'evil',
                type: 'address',
            },
        ],
        name: 'NotManager',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'fakeInstrument',
                type: 'address',
            },
        ],
        name: 'NotSynFuturesInstrument',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NotTradeable',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NotWrappedNative',
        type: 'error',
    },
    {
        inputs: [],
        name: 'OwedShareExists',
        type: 'error',
    },
    {
        inputs: [],
        name: 'SuspendedVault',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'deposit',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'threshold',
                type: 'uint256',
            },
        ],
        name: 'TrivialDeposit',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'received',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'expected',
                type: 'uint256',
            },
        ],
        name: 'UnexplainableWithdrawal',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
        ],
        name: 'UnsafeToken',
        type: 'error',
    },
    {
        inputs: [],
        name: 'VaultBankrupt',
        type: 'error',
    },
    {
        inputs: [],
        name: 'ZeroAddress',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint32',
                name: 'expiry',
                type: 'uint32',
            },
        ],
        name: 'AddInvolvedPair',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'native',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'quantity',
                type: 'uint256',
            },
        ],
        name: 'Deposit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'depositor',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'native',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'quantity',
                type: 'uint256',
            },
        ],
        name: 'DepositFor',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint8',
                name: 'version',
                type: 'uint8',
            },
        ],
        name: 'Initialized',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint32',
                name: 'expiry',
                type: 'uint32',
            },
        ],
        name: 'RemoveInvolvedPair',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: 'enum Stage',
                        name: 'stage',
                        type: 'uint8',
                    },
                    {
                        internalType: 'address',
                        name: 'quote',
                        type: 'address',
                    },
                    {
                        internalType: 'uint8',
                        name: 'decimals',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxPair',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxRange',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxOrder',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint16',
                        name: 'commissionRatio',
                        type: 'uint16',
                    },
                    {
                        internalType: 'uint128',
                        name: 'minQuoteAmount',
                        type: 'uint128',
                    },
                    {
                        internalType: 'uint128',
                        name: 'liveThreshold',
                        type: 'uint128',
                    },
                ],
                indexed: false,
                internalType: 'struct Configuration',
                name: 'config',
                type: 'tuple',
            },
        ],
        name: 'SetConfiguration',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'newManager',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'oldManager',
                type: 'address',
            },
        ],
        name: 'SetManager',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'commission',
                type: 'uint256',
            },
        ],
        name: 'UpdateCommission',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'owedShare',
                type: 'uint256',
            },
        ],
        name: 'UpdateOwedShare',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                components: [
                    {
                        internalType: 'uint128',
                        name: 'share',
                        type: 'uint128',
                    },
                    {
                        internalType: 'uint128',
                        name: 'entryValue',
                        type: 'uint128',
                    },
                ],
                indexed: false,
                internalType: 'struct Stake',
                name: 'stake',
                type: 'tuple',
            },
        ],
        name: 'UpdateStake',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'totalShare',
                type: 'uint256',
            },
        ],
        name: 'UpdateTotalShare',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'native',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'quantity',
                type: 'uint256',
            },
        ],
        name: 'Withdraw',
        type: 'event',
    },
    {
        inputs: [],
        name: 'RATIO_BASE',
        outputs: [
            {
                internalType: 'uint16',
                name: '',
                type: 'uint16',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'bytes32[2]',
                name: 'args',
                type: 'bytes32[2]',
            },
        ],
        name: 'add',
        outputs: [
            {
                internalType: 'int24',
                name: 'tickLower',
                type: 'int24',
            },
            {
                internalType: 'int24',
                name: 'tickUpper',
                type: 'int24',
            },
            {
                components: [
                    {
                        internalType: 'uint128',
                        name: 'liquidity',
                        type: 'uint128',
                    },
                    {
                        internalType: 'uint128',
                        name: 'entryFeeIndex',
                        type: 'uint128',
                    },
                    {
                        internalType: 'uint96',
                        name: 'balance',
                        type: 'uint96',
                    },
                    {
                        internalType: 'uint160',
                        name: 'sqrtEntryPX96',
                        type: 'uint160',
                    },
                ],
                internalType: 'struct Range',
                name: 'range',
                type: 'tuple',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: 'expiry',
                type: 'uint32',
            },
            {
                internalType: 'uint240[3]',
                name: 'encodedTicks',
                type: 'uint240[3]',
            },
        ],
        name: 'batchCancel',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'bytes32[3]',
                name: 'args',
                type: 'bytes32[3]',
            },
        ],
        name: 'batchPlace',
        outputs: [
            {
                internalType: 'uint24[]',
                name: '',
                type: 'uint24[]',
            },
            {
                components: [
                    {
                        internalType: 'uint128',
                        name: 'balance',
                        type: 'uint128',
                    },
                    {
                        internalType: 'int128',
                        name: 'size',
                        type: 'int128',
                    },
                ],
                internalType: 'struct Order[]',
                name: '',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bool',
                name: 'native',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'collectCommission',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'commission',
        outputs: [
            {
                internalType: 'uint128',
                name: '',
                type: 'uint128',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'quantity',
                type: 'uint256',
            },
        ],
        name: 'deposit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'quantity',
                type: 'uint256',
            },
        ],
        name: 'depositFor',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'quantity',
                type: 'uint256',
            },
        ],
        name: 'donate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'factory',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'bytes32',
                name: 'arg',
                type: 'bytes32',
            },
        ],
        name: 'fill',
        outputs: [
            {
                components: [
                    {
                        internalType: 'int256',
                        name: 'balance',
                        type: 'int256',
                    },
                    {
                        internalType: 'int256',
                        name: 'size',
                        type: 'int256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'entryNotional',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'entrySocialLossIndex',
                        type: 'uint256',
                    },
                    {
                        internalType: 'int256',
                        name: 'entryFundingIndex',
                        type: 'int256',
                    },
                ],
                internalType: 'struct PositionCache',
                name: 'pos',
                type: 'tuple',
            },
            {
                internalType: 'uint256',
                name: 'tip',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'gate',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getConfiguration',
        outputs: [
            {
                components: [
                    {
                        internalType: 'enum Stage',
                        name: 'stage',
                        type: 'uint8',
                    },
                    {
                        internalType: 'address',
                        name: 'quote',
                        type: 'address',
                    },
                    {
                        internalType: 'uint8',
                        name: 'decimals',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxPair',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxRange',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxOrder',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint16',
                        name: 'commissionRatio',
                        type: 'uint16',
                    },
                    {
                        internalType: 'uint128',
                        name: 'minQuoteAmount',
                        type: 'uint128',
                    },
                    {
                        internalType: 'uint128',
                        name: 'liveThreshold',
                        type: 'uint128',
                    },
                ],
                internalType: 'struct Configuration',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getInvolvedPairs',
        outputs: [
            {
                internalType: 'address[]',
                name: 'instruments',
                type: 'address[]',
            },
            {
                internalType: 'uint32[]',
                name: 'expiries',
                type: 'uint32[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
        ],
        name: 'getOwedQuote',
        outputs: [
            {
                internalType: 'uint256',
                name: 'netValue',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'commissionFee',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getPortfolioValue',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
        ],
        name: 'getStake',
        outputs: [
            {
                components: [
                    {
                        internalType: 'uint128',
                        name: 'share',
                        type: 'uint128',
                    },
                    {
                        internalType: 'uint128',
                        name: 'entryValue',
                        type: 'uint128',
                    },
                ],
                internalType: 'struct Stake',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_factory',
                type: 'address',
            },
            {
                internalType: 'string',
                name: '_name',
                type: 'string',
            },
            {
                internalType: 'address',
                name: '_manager',
                type: 'address',
            },
            {
                components: [
                    {
                        internalType: 'enum Stage',
                        name: 'stage',
                        type: 'uint8',
                    },
                    {
                        internalType: 'address',
                        name: 'quote',
                        type: 'address',
                    },
                    {
                        internalType: 'uint8',
                        name: 'decimals',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxPair',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxRange',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint8',
                        name: 'maxOrder',
                        type: 'uint8',
                    },
                    {
                        internalType: 'uint16',
                        name: 'commissionRatio',
                        type: 'uint16',
                    },
                    {
                        internalType: 'uint128',
                        name: 'minQuoteAmount',
                        type: 'uint128',
                    },
                    {
                        internalType: 'uint128',
                        name: 'liveThreshold',
                        type: 'uint128',
                    },
                ],
                internalType: 'struct Configuration',
                name: '_configuration',
                type: 'tuple',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'share',
                type: 'uint256',
            },
        ],
        name: 'inquireWithdrawal',
        outputs: [
            {
                internalType: 'bool',
                name: 'availableNow',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'netValue',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'commissionFee',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'mtype',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
            {
                internalType: 'bytes32[2]',
                name: 'addArgs',
                type: 'bytes32[2]',
            },
        ],
        name: 'launch',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: 'expiry',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: 'target',
                type: 'address',
            },
            {
                internalType: 'int256',
                name: 'size',
                type: 'int256',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'liquidate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'manager',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
        ],
        name: 'owedShareOf',
        outputs: [
            {
                internalType: 'uint256',
                name: 'owedShare',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'users',
                type: 'address[]',
            },
        ],
        name: 'payoff',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'bytes32[2]',
                name: 'args',
                type: 'bytes32[2]',
            },
        ],
        name: 'place',
        outputs: [
            {
                internalType: 'uint24',
                name: 'nonce',
                type: 'uint24',
            },
            {
                components: [
                    {
                        internalType: 'uint128',
                        name: 'balance',
                        type: 'uint128',
                    },
                    {
                        internalType: 'int128',
                        name: 'size',
                        type: 'int128',
                    },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'bytes32[2]',
                name: 'args',
                type: 'bytes32[2]',
            },
        ],
        name: 'remove',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint16',
                name: 'newCommissionRatio',
                type: 'uint16',
            },
        ],
        name: 'setCommissionRatio',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint128',
                name: 'newLiveThreshold',
                type: 'uint128',
            },
        ],
        name: 'setLiveThreshold',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newManager',
                type: 'address',
            },
        ],
        name: 'setManager',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint128',
                name: 'newMinQuoteAmount',
                type: 'uint128',
            },
        ],
        name: 'setMinQuoteAmount',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint8',
                name: 'newMaxPair',
                type: 'uint8',
            },
            {
                internalType: 'uint8',
                name: 'newMaxRange',
                type: 'uint8',
            },
            {
                internalType: 'uint8',
                name: 'newMaxOrder',
                type: 'uint8',
            },
        ],
        name: 'setPortfolioLimit',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'enum Stage',
                name: 'newStage',
                type: 'uint8',
            },
        ],
        name: 'setStage',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: 'expiry',
                type: 'uint32',
            },
        ],
        name: 'settle',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalShare',
        outputs: [
            {
                internalType: 'uint128',
                name: '',
                type: 'uint128',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'instrument',
                type: 'address',
            },
            {
                internalType: 'bytes32[2]',
                name: 'args',
                type: 'bytes32[2]',
            },
        ],
        name: 'trade',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'weth',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bool',
                name: 'native',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'share',
                type: 'uint256',
            },
        ],
        name: 'withdraw',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
const _bytecode = '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$6472d8096db147f599f04e9210f50e0381$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$6472d8096db147f599f04e9210f50e0381$__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__$6472d8096db147f599f04e9210f50e0381$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';
const isSuperArgs = (xs) => {
    return (typeof xs[0] === 'string' ||
        Array.isArray(xs[0]) ||
        '_isInterface' in xs[0]);
};
class Vault__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, Vault__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp('__\\$6472d8096db147f599f04e9210f50e0381\\$__', 'g'), linkLibraryAddresses['contracts/peripheral/vault/LibVault.sol:LibVault'].replace(/^0x/, '').toLowerCase());
        return linkedBytecode;
    }
    deploy(_gate, _weth, overrides) {
        return super.deploy(_gate, _weth, overrides || {});
    }
    getDeployTransaction(_gate, _weth, overrides) {
        return super.getDeployTransaction(_gate, _weth, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Vault__factory = Vault__factory;
Vault__factory.bytecode = _bytecode;
Vault__factory.abi = _abi;
